<section>
    <div *ngFor="let dailyItem of dailyContents; let i = index">
        <span [class.currentDay]="isToday(dailyItem.date)">
            {{dailyItem.date | date: 'EEEEE' | uppercase}}
        </span>
        <opac-progress-spinner *ngIf="(progressCount[i] | async) !== undefined" [progress]="progressCount[i] | async" progressText="%"></opac-progress-spinner>
    </div>
</section>
